<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '12px' }"></ngx-loading>
<div class="app-content content permission-editor">
  <div class="content-wrapper">
    <div class="alert alert-light-danger" role="alert" *ngIf="loadError">
      <p class="mb-3">{{ loadError }}</p>
      <button type="button" class="btn btn-primary mr-2" *ngIf="canRetryLoad" [disabled]="loading" (click)="reloadProfile()">Reintentar</button>
      <a class="btn btn-secondary" [routerLink]="returnURL">Volver a Perfiles</a>
    </div>

    <div class="permission-panel" *ngIf="currentProfile">
      <header class="permission-overview">
        <div class="profile-heading">
          <div class="profile-intro">
            <span class="section-label">Perfiles y accesos</span>
            <h1>Permisos para el perfil {{ profileDisplayName }}</h1>
            <p>{{ profileDescription }}</p>
          </div>
          <div class="profile-actions">
            <a class="btn btn-light" [routerLink]="returnURL" [class.disabled]="loading" [attr.aria-disabled]="loading"><i class="fas fa-arrow-left" aria-hidden="true"></i> Volver</a>
            <button type="button" class="btn btn-success save-button" (click)="sendPermissionsList()"
              *ngIf="permissions.getPermission('30-50-14').asignado" [disabled]="loading || !hasChanges">
              <i class="fas fa-plus" aria-hidden="true"></i> {{ loading ? 'Guardando…' : 'Guardar cambios' }}
            </button>
          </div>
        </div>

      </header>
      <div class="permission-content">
        <div class="permission-summary">
          <span class="summary-icon" aria-hidden="true"><i class="fas fa-shield-alt"></i></span>
          <div class="summary-copy">
            <strong class="summary-number">{{ assignedCount }} permisos activos</strong>
            <span class="summary-label">de {{ totalCount }} disponibles para este perfil</span>
          </div>
          <div class="summary-progress">
            <div class="progress" role="progressbar" aria-label="Porcentaje de permisos activos"
              [attr.aria-valuenow]="percentage" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" [style.width.%]="percentage"></div>
            </div>
          </div>
          <strong class="summary-percentage">{{ percentage }}%</strong>
        </div>

        <div class="permission-toolbar">
          <div class="permission-search">
            <label class="sr-only" for="permission-search">Buscar permiso o módulo</label>
            <div class="search-control">
              <i class="fas fa-search" aria-hidden="true"></i>
              <input id="permission-search" type="search" class="form-control" placeholder="Buscar permiso o módulo"
                [(ngModel)]="searchTerm" (ngModelChange)="filterCategories()" autocomplete="off" />
            </div>
          </div>
          <div class="toolbar-actions">
            <button type="button" class="btn toolbar-button" *ngIf="permissions.getPermission('30-50-14').asignado"
              [attr.aria-pressed]="allAssigned" [disabled]="loading || !totalCount" (click)="setAll(!allAssigned)">
              <i class="fas fa-sliders-h" aria-hidden="true"></i> {{ allAssigned ? 'Deseleccionar todo' : 'Seleccionar todo' }}
            </button>
            <button type="button" class="btn toolbar-button" (click)="toggleExpanded()" [disabled]="!visibleCategories.length">
              <i class="fas" [class.fa-angle-double-up]="allExpanded" [class.fa-angle-double-down]="!allExpanded" aria-hidden="true"></i>
              {{ allExpanded ? 'Colapsar todo' : 'Expandir todo' }}
            </button>
          </div>
        </div>
        <p class="selection-hint" *ngIf="searchTerm">Seleccionar un módulo activa todos sus permisos, incluso los que no coinciden con la búsqueda. Seleccionar todo incluye todos los módulos.</p>
        <p class="search-count" *ngIf="searchTerm" role="status">{{ visibleCount }} permisos en {{ visibleCategories.length }} módulos</p>

        <div class="permission-grid">
          <div class="permission-column" *ngFor="let column of visibleColumns">
            <section class="permission-category" *ngFor="let category of column; trackBy: trackCategory" [style.order]="category.order">
              <div class="category-header">
                <button type="button" class="category-heading" (click)="category.expanded = !category.expanded"
                  [attr.aria-expanded]="category.expanded" [attr.aria-controls]="'category-' + category.id">
                  <span class="category-chevron" [class.is-expanded]="category.expanded" aria-hidden="true">›</span>
                  <span class="category-copy">
                    <span class="category-title">{{ category.title }}</span>
                    <span class="category-description">{{ category.items.length }} {{ category.items.length === 1 ? 'permiso disponible' : 'permisos disponibles' }} en este módulo</span>
                  </span>
                </button>
                <span class="category-count">{{ countAssigned(category) }}/{{ category.items.length }} activos</span>
                <label class="permission-switch category-switch" *ngIf="permissions.getPermission('30-50-14').asignado">
                  <input type="checkbox" role="switch" [checked]="countAssigned(category) === category.items.length"
                    [disabled]="loading" [attr.aria-label]="'Activar todos los permisos de ' + category.title"
                    (change)="setCategory(category, $event.target.checked)" />
                  <span class="switch-track" aria-hidden="true"></span>
                </label>
              </div>
              <div class="category-body" [id]="'category-' + category.id" [hidden]="!category.expanded">
                <label class="permission-row" *ngFor="let item of category.visibleItems; trackBy: trackPermission">
                  <span class="permission-copy">
                    <span class="permission-title">{{ item.title }}</span>
                    <span class="permission-description">{{ item.description }}</span>
                  </span>
                  <span class="permission-switch">
                    <input type="checkbox" role="switch" [(ngModel)]="item.permission.asignado" [attr.aria-label]="item.title"
                      [disabled]="loading || !permissions.getPermission('30-50-14').asignado" />
                    <span class="switch-track" aria-hidden="true"></span>
                  </span>
                </label>
              </div>
            </section>
          </div>
        </div>
        <span class="save-status" *ngIf="hasChanges" role="status">Cambios sin guardar</span>
        <div class="permission-empty" *ngIf="!visibleCategories.length" role="status">
          <i class="fas fa-search" aria-hidden="true"></i>
          <h2>{{ totalCount ? 'No encontramos coincidencias' : 'No hay permisos disponibles' }}</h2>
          <p>{{ totalCount ? 'Prueba con otro nombre de permiso o módulo.' : 'Este perfil no tiene permisos disponibles para editar.' }}</p>
          <button type="button" class="btn btn-light-primary" *ngIf="searchTerm" (click)="searchTerm = ''; filterCategories()">Limpiar búsqueda</button>
        </div>
      </div>
    </div>
  </div>
</div>
